import { useEffect } from "react";

// Anything under /us now lives on the standalone outcess.us site.
// This component sends visitors there, preserving the sub-path
// (e.g. /us/services -> https://outcess.us/services).
function RedirectToUSSite({ location }) {
  useEffect(() => {
    const subPath = location.pathname.replace(/^\/us/, "");
    window.location.replace(
      `https://outcess.us${subPath}${location.search || ""}`
    );
  }, [location]);

  return null;
}

export default RedirectToUSSite;
